import { useEffect, useState } from 'react';

import { apiUrl } from './constants';

export const useAraTiquetsConfiguration = () => {
  const [configuration, setConfiguration] = useState({});

  useEffect(() => {
    let mounted = true;

    fetch(`${apiUrl}/ara-tiquets/configuration/public`)
      .then(response => {
        if (!response.ok) throw new Error('ara_tiquets_configuration_load_error');
        return response.json();
      })
      .then(data => {
        if (mounted) setConfiguration(data);
      })
      .catch(() => {
        if (mounted) setConfiguration({});
      });

    return () => { mounted = false; };
  }, []);

  return configuration;
};
